import { ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { OddsDisplayFormat } from '@frontend/sports/types/models/user-settings';
import { UserStateService } from '@frontend/sports/user/feature';
import { Store } from '@ngrx/store';
import { Observable, map } from 'rxjs';

import { IBetslipRootState } from '../../../../base/store/state';
import { BetslipPick } from '../../../../core/picks/betslip-pick';
import { betslipPickStateSelector } from '../../../picks/selectors';
import { IBetslipPickState, IPickUiState, defaultPickUiState } from '../../../picks/state';
import { editBetStateSelector } from '../../../types/selectors';
import { IEditMyBetState } from '../../state';

@Component({
    selector: 'bs-edit-bet-pick-container',
    templateUrl: './edit-bet-pick-container.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./edit-bet-pick-container.scss'],
    standalone: false,
})
export default class EditBetPickContainerComponent implements OnInit {
    editBetState$: Observable<IEditMyBetState>;
    oddsDisplayFormat$: Observable<OddsDisplayFormat>;
    picksUi: Record<string, IPickUiState>;
    pickUIState: IPickUiState;

    private readonly destroyRef = inject(DestroyRef);

    constructor(
        userState: UserStateService,
        public store: Store<IBetslipRootState>,
        protected changeDetector: ChangeDetectorRef,
    ) {
        this.editBetState$ = store.select(editBetStateSelector);

        this.oddsDisplayFormat$ = userState.userState$().pipe(map((state) => state.oddsFormat || OddsDisplayFormat.EU));
    }

    ngOnInit(): void {
        this.store
            .select(betslipPickStateSelector)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((next: IBetslipPickState) => {
                this.picksUi = next.ui;
                this.changeDetector.markForCheck();
            });
    }

    pickTrackBy(_: number, pick: BetslipPick): string {
        return pick.id.toString();
    }

    getPickUi(pick: BetslipPick): IPickUiState {
        return this.picksUi[pick?.id.toString()] || defaultPickUiState;
    }
}
